import { documentTypeId } from 'Utils/constants'
import {
  AddUpdateSalesDocumentsService,
  searchSalesDocumentDetailService,
  UpdateApprovalSalesOrder,
} from 'redux/services/cotizacionServices'

export const updateProductsAuth = async ({
  saleOrderDocHeaderId,
  saleOrderDocumentNumber,
  user,
}) => {
  try {
    const { allOdvData, odvProducts } = await fetchDocumentODV(
      saleOrderDocHeaderId,
      saleOrderDocumentNumber
    )
    const prodsUpdated = odvProducts?.map(item => {
      return {
        ...item,
        AuthorizedPriceBy: user?.UserId,
        AuthorizedPriceByName: user?.UserName,
      }
    })

    const updatedProducts = allOdvData?.Lines?.map(originalProduct => {
      const productFiltered = prodsUpdated.find(
        item => item.SystemCode === originalProduct.SystemCode
      )
      return productFiltered
        ? { ...originalProduct, ...productFiltered }
        : originalProduct
    })

    const payload = {
      DocumentTypeId: documentTypeId.ODV,
      SalesOrder: {
        SalesOrderHeaderId: saleOrderDocHeaderId,
        QtyOutstanding: 0,
        ...allOdvData,
        Lines: updatedProducts,
        AuthorizedPriceBy: user?.AuthenticationInfo?.userId,
        AuthorizedPriceByName: user?.AuthenticationInfo?.userName,
      },
    }

    const response = await AddUpdateSalesDocumentsService(payload)
    const documentHeaderID =
      response?.data?.Data?.SalesDocumentInfo?.DocHeaderId || ''

    if (documentHeaderID) {
      await UpdateApprovalSalesOrder({
        DocumentHeaderId: documentHeaderID,
        Approve: true,
      })
    }
  } catch (error) {
    console.error('Error to try update product and documents:', error)
  }
}

export const fetchDocumentODV = async (
  saleOrderDocHeaderId,
  saleOrderDocumentNumber
) => {
  const payload = {
    DocumentTypeId: documentTypeId.ODV,
    DocumentHeaderId: saleOrderDocHeaderId,
    DocumentNumber: saleOrderDocumentNumber,
    PageNumber: 1,
    PageSize: 1,
  }

  try {
    const response = await searchSalesDocumentDetailService(payload)
    const addSalesOrderLineId =
      response?.data?.Data?.Lines?.map(prod => ({
        ...prod,
        SalesOrderLineId: prod.DocLineId,
      })) || []

    const allOdvData = {
      ...response?.data?.Data,
      Lines: addSalesOrderLineId,
    }

    const productsNeedAuth = addSalesOrderLineId.filter(
      prod =>
        prod.Price < prod.FinalPrice &&
        prod.AuthorizedPriceBy === null &&
        prod.AuthorizedPriceByName === null
    )
    const productsWithIsChecked = productsNeedAuth.map(product => ({
      ...product,
      isChecked: true,
    }))

    return {
      allOdvData,
      odvProducts: productsWithIsChecked,
    }
  } catch (error) {
    console.error('Error to get document detail', error)
    throw error
  }
}
